import React, {Component} from 'react';
import autobind from 'autobind-decorator'
import { connect } from "react-redux";
import fetch from "fetch-retry";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import * as InitStatus from "../../../constants/common/InitializationStatus";
import {number_format} from '../../../utils/formatter';
import If from "../../common/control/If";
import {addPrefix} from "../../../utils/UriUtil";


@connect(state => ({
  activeDate: state.statistics.activeDate,
  activeDateType: state.statistics.activeDateType,
}), dispatch => ({dispatch}))
class BlogKeyword extends Component {

  constructor(props) {
    super(props);
    this.state = this.getDefaultState()

  }

  // 초기 state
  getDefaultState() {
    return {
      initialized: InitStatus.INIT_READY,
      keywordData: []
    };
  }

  // Active date, type을 Watching한다.
  shouldComponentUpdate(nextProps, nextState) {
    if (this.checkIsChangedActiveDateOrType(nextProps)) {
      this.getKeyword(nextProps)
    }
    return true;
  }

  // 날짜, 타입 변경여부
  @autobind
  checkIsChangedActiveDateOrType(nextProps) {
    const {activeDate, activeDateType} = this.props;
    return activeDate != nextProps.activeDate || activeDateType != nextProps.activeDateType;
  }

  // 인기 키워드 호출
  @autobind
  getKeyword(nextProps) {
    const {activeDate, activeDateType, dispatch} = nextProps;

    this.setState({initialized: InitStatus.INIT_DOING}, () => {
      fetch(addPrefix(`/manage/statistics/blog/${activeDate}/${activeDateType}/keyword.json`), {
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        retries: 2,
        retryDelay: 300,
        retryOn: [500],
      })
        .then(jsonResponseHandler(dispatch))
        .then(res => res.json())
        .then(res => {
          this.setState({
            keywordData: res.data,
            initialized: InitStatus.INIT_SUCCESS
          });
        })
        .catch(e => {
          console.log('error:', e);
          this.setState({initialized: InitStatus.INIT_FAIL});
          alert('통계 정보를 조회할 수 없습니다. 잠시 후 다시 시도해 주시기 바랍니다.');
        })
    });
  }

  renderLoading() {
    return <div className="date_loading">
      <div className="inner_g"><span className="ico_blog ico_loading">로딩중입니다.</span></div>
    </div>;
  }

  // 리스트 HTML
  @autobind
  renderList(list) {
    return list.map((item, index) => (
      <li key={index}>
            <span className="btn_keyword">
                <span className="txt_keyword">{item.keyword}</span><span className="num_keyword">{number_format(item.count)}</span>
            </span>
      </li>
    ));
  }

  render() {
    const {keywordData, initialized} = this.state;
    const list = keywordData.hasOwnProperty('result') ? keywordData.result : [];
    const {isDoing, isFail, isEmpty, isSuccess} = InitStatus.init(initialized, list);

    return (
      <div className="incomming_keyword">
        <strong className="tit_incomming"><span className="txt_question">유입 키워드</span></strong>
        <If condition={isEmpty}><p className="desc_message">검색 유입 키워드가 없습니다.</p></If>
        <If condition={isDoing}>{this.renderLoading()}</If>
        <If condition={isSuccess}>
          <h4 className="screen_out">유입키워드 목록</h4>
          <ul className="list_keyword">
            {this.renderList(list)}
          </ul>
        </If>
      </div>
    );
  }
}

export default BlogKeyword;
